"use client";
import { User } from "@/models/user";
import { hash256 } from "@/utils/string";

declare global {
  interface Window {
    dataLayer?: any[];
  }
}

export function pushUserIdToDataLayer(user: User) {
  try {
    if (typeof window === "undefined") return;
    const hash256Email = hash256(user?.email || "");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "set_user",
      user_id: String(user?.id || ""),
      user_email_raw: user?.email || "",
      user_email_hashed: hash256Email || "",
      user_first_name: user?.firstName || "",
      user_last_name: user?.lastName || "",
      plan_name: user?.license?.subscription?.name || "",
      is_trial: user?.license?.isTrial ? "true" : "false",
    });
  } catch (error) {
    console.error("Error pushing user data to dataLayer:", error);
  }
}
